import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const AskInputPlusMenuScreenshot = memo(function AskInputPlusMenuScreenshot({ onCaptureScreenshot, isScreenshotDisabledByOrg, tooltipMaxWidth, }) {
    const { $t } = useIntl();
    const isSidecar = !!import.meta.env.VITE_IS_SIDECAR_BUILD;
    const disabledByOrgMessage = $t({
        defaultMessage: 'Disabled by your organization',
        description: 'Tooltip shown when screenshot feature is disabled by the organization',
        id: 'ebb4c3886b',
    });
    return (_jsx(Tooltip, { content: disabledByOrgMessage, side: "right", disabled: !isScreenshotDisabledByOrg || isSidecar, maxWidthPx: tooltipMaxWidth, children: _jsx(DropdownMenu.Item, { leadingAccessory: $icon('capture'), onSelect: onCaptureScreenshot, disabled: isScreenshotDisabledByOrg, subtitle: isSidecar && isScreenshotDisabledByOrg ? disabledByOrgMessage : undefined, children: _jsx(FormattedMessage, { defaultMessage: "Screenshot", description: "Menu item label for the screenshot capture option", id: "80afa7abcf" }) }) }));
});
//# sourceMappingURL=AskInputPlusMenuScreenshot.js.map